*,
::after,
::before {
  box-sizing: border-box;
}

:host {
  position: relative;
  contain: size;
  display: block;
}

canvas {
  cursor: crosshair;
  inline-size: 100%;
  block-size: 100%;
}

.marker {
  position: absolute;
  inline-size: var(--ch-color-field__marker-size);
  block-size: var(--ch-color-field__marker-size);
  border-radius: 50%;
  border: 1px solid currentColor;
  pointer-events: none;
  transform: translate(-50%, -50%);
}